import { useState, useEffect } from 'react';
import { InnocodePaymentCardInfo, InnocodePaymentListHorizental } from '@intsoft/innocode-payment';
import { InnocodePaginationGroup, InnocodeTextButton } from '@intsoft/innocode-core';
import { PaymentType, getPaymentTypeColor, getPaymentTypeLabel } from '../../../resources/utils/paymentUtils';
import { useNavigate } from 'react-router-dom';
import styles from './PaymentHistory.module.css';
import { ZENPAY_PAYMENT } from '../../../utils/Config';
import { getCookie } from '../../../utils/cookies/cookies';
import axios from "../../../utils/api/axios";
import moment from 'moment';


export interface paymentHistoryInfo {
  paymentId: string;
  paymentDate: string;
  paymentAmount: number;
  paymentStatus: PaymentType;
  paymentTitle?: string;
  paymentEtc?: string;
  paymentThumbnailUrl?: string;
}

export default function Page() {
  const [platform, setPlatform] = useState<'web' | 'tablet-vertical' | 'mobile'>('web');
  const navigate = useNavigate();
  const [enableDeleteMode, setEnableDeleteMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const [paymentHistoryList, setPaymentHistoryList] = useState<paymentHistoryInfo[]>([

  ]);

  // 페이지네이션 상태
  const listSize = 10; // 한 페이지당 보여줄 항목 수
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const toggleDeleteMode = () => {
    setEnableDeleteMode(!enableDeleteMode);
  };

  const getPlatform = (width: number): 'web' | 'tablet-vertical' | 'mobile' => {
    if (width < 768) return 'mobile';
    if (width < 1440) return 'tablet-vertical';
    return 'web';
  };

  useEffect(() => {
    getPaymentHistory(0);
  }, []);


  // 페이지 이동 핸들러
  const handlePageChange = (page: number) => {
    if (page < 0 || page >= totalPages) return;
    setCurrentPage(page);
  };

  useEffect(() => {
    getPaymentHistory(currentPage);
  }, [currentPage]);


  useEffect(() => {
    // 초기 사이즈 설정 
    setPlatform(getPlatform(window.innerWidth));
    // 윈도우 리사이즈 이벤트 핸들러
    const handleResize = () => {
      setPlatform(getPlatform(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);

    // 클린업 함수
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const getPaymentHistory = async (page: number) => {
    setLoading(true);
    try {

      const user = JSON.parse(getCookie("user"));
      const profileList = user.sub_profile;

      //profileList에서 profile_id찾아서 id리스트 만들기
      let profileIds = profileList.map((profile: any) => profile.profile_id);
      profileIds.push(getCookie("user_id"));
      profileIds = profileIds.join(',');

      const url = ZENPAY_PAYMENT + "/all";
      const conditions = [
        { field: "customerId", operator: "IN", value: profileIds },
        // { field: "customerId", operator: "EQUALS", value: getCookie("user_id") },
        { field: "isDeleteHistory", operator: "EQUALS", value: false }
      ];
      const params = {
        page: page,
        size: listSize,
        sortField: ['paymentPaidDate'],
        sortOrder: ['desc'],
        operator: "AND",
        conditions
      };

      const res = await axios.post(url, params);

      const { data, recordsTotal } = res.data.data;

      console.log('data', data);

      //data는 paymentHistoryInfo 맞게 가공이 필요
      const transformedPaymentHistoryList: paymentHistoryInfo[] = data.map((payment: any) => {
        return {
          paymentId: payment.id,
          paymentDate: payment.paymentPaidDate,
          paymentAmount: payment.totalAmount,
          paymentStatus: payment.paymentStatus,
          paymentTitle: payment.paymentInfo.orderName,
          paymentEtc: payment.etc,
          paymentThumbnailUrl: payment.paymentInfo.orderImagUrl ? payment.paymentInfo.orderImagUrl : undefined,
        };
      });




      setPaymentHistoryList(transformedPaymentHistoryList);
      setTotalPages(Math.max(1, Math.ceil(recordsTotal / listSize)));

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // 날짜별로 그룹화
  const groupedByDate = paymentHistoryList.reduce((acc, payment) => {
    const dateKey = moment(payment.paymentDate).format('YYYY-MM-DD');
    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(payment);
    return acc;
  }, {} as Record<string, paymentHistoryInfo[]>);

  // 날짜를 내림차순으로 정렬
  const sortedDates = Object.keys(groupedByDate).sort((a, b) => b.localeCompare(a));

  return (
    <div className="content-wrapper">
      <div className={styles.pageWrapper}>
        <div className={styles.titleSection}>
          <h3>결제 내역</h3>
        </div>
        <div className={styles.contentSection}>
          {sortedDates.length === 0 ? (
            <div className={styles.emptyState}> 
              <p className={styles.emptyTitle}>결제 내역이 없습니다</p>
              <p className={styles.emptyDescription}>아직 결제한 내역이 없습니다.</p>
            </div>
          ) : (
            sortedDates.map((date) => (
              <div className={styles.dateListWrapper} key={date}>
                <p className={styles.dateTitle}>{date}</p>
                <div className={styles.dateList}>
                  {groupedByDate[date].map((payment) => (
                    <InnocodePaymentListHorizental
                      key={payment.paymentId}
                      className="list_item"
                      size={platform == "web" ? "lg" : "md"}
                      status="default"
                      showPaymentStatus={true}
                      showPaymentDetail={platform == "web" ? false : true}
                      onPaymentDetailClick={() => {
                        // alert(`[MOBILE] 결제 상세보기: ${payment.paymentId}`);
                        navigate(`/payment_history/detail/${payment.paymentId}?enableGobackBar=true`);
                      }}
                      paymentStatus={getPaymentTypeLabel(payment.paymentStatus)}
                      paymentStatusColor={getPaymentTypeColor(payment.paymentStatus)}
                      leadingThumbnail={true}
                      thumbnailSrc={payment.paymentThumbnailUrl || undefined}
                      thumbnailAlt="썸네일 이미지"
                      showThumbnailBadge={false}
                      thumbnailSize="sm"
                      showStoreInfo={false}
                      showTitle={true}
                      title={payment.paymentTitle || ''}
                      showDescription={false}
                      showBottomContents={true}
                      showAmount={true}
                      amount={payment.paymentAmount}
                      showPaymentDate={true}
                      paymentDate={`${payment.paymentDate} 결제`}
                      showButton={platform == "web" ? true : false}
                      onButtonClick={() => {
                        // alert(`[WEB] 결제 상세보기: ${payment.paymentId}`);
                      }}
                      onClick={() => {
                        navigate(`/payment_history/detail/${payment.paymentId}?enableGobackBar=true`);
                        // alert(`결제 내역 클릭: ${payment.paymentTitle}`);
                      }}
                    />
                  ))}
                </div>
              </div>
            ))
          )}

        </div>
        <InnocodePaginationGroup
          width={100}
          totalPages={totalPages}
          currentPage={currentPage + 1}
          onPageChange={(page: number) => {
            handlePageChange(page - 1);
          }}
          onPrevious={() => {
            handlePageChange(currentPage - 1)
          }}
          onNext={() => {
            handlePageChange(currentPage + 1);
          }}
          onFirst={() => {
            handlePageChange(0);
          }}
          onLast={() => {
            handlePageChange(totalPages - 1);
          }}
          showNavigation={true}
          showFirstLast={true}
          showEllipsis={true}
          pageRange={10}
        ></InnocodePaginationGroup>
      </div>
    </div>

  );
}
